import { render, staticRenderFns } from "./ShieldBios.vue?vue&type=template&id=53c0470a&scoped=true&"
import script from "./ShieldBios.vue?vue&type=script&lang=js&"
export * from "./ShieldBios.vue?vue&type=script&lang=js&"
import style0 from "./ShieldBios.vue?vue&type=style&index=0&id=53c0470a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0470a",
  null
  
)

export default component.exports